import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import Grid from "@mui/material/Grid";

import "./style.css";

const drawerWidth = 240;

class SubjectSecret extends Component<any, any> {
    constructor(props: any) {
        super(props);

        this.resetStats = this.resetStats.bind(this);
    }

    public render() {
        return (
            <Grid container direction="row">
                <button onClick={this.resetStats}>
                    Reset Stats(Warning: Permanent)
                </button>
            </Grid>
        );
    }

    private resetStats() {
        this.props.rootStore.subjectStore.resetStats(
            this.props.match.params.user,
            this.props.match.params.subject
        );
    }
}

export default observer(SubjectSecret);
